import { MediaQueryBreakPoint, TypographyVariant } from '@execonline-inc/execonline-ui';

export const getStartDateVariant = (breakPoint: MediaQueryBreakPoint): TypographyVariant => {
  switch (breakPoint) {
    case 'xl':
    case 'lg':
    case 'md':
    case 'sm':
      return 'h5';
    case 'xs':
      return 'subtitleMedium';
  }
};
